import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "none",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4B5563",
      d: "M8 15.09a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0 1a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4B5563",
      d: "m8.93 6.679-2.29.287-.082.38.45.083c.294.07.352.175.288.468l-.738 3.47c-.194.896.105 1.318.808 1.318.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.59a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    }, null, -1)
  ]))]))
}
export default { render: render }